{
  class ajaxRenderer extends HTMLElement {
    connectedCallback() {
      // admin preview hack fix because gutenberg doesn't like custom elements
      if(this.hasAttribute('className')){
        this.classList = this.getAttribute('className')
        this.removeAttribute('className')
      }

      jQuery.ajax({
        url: window.coolfse.ajaxUrl, //localized variable
        data: { action: 'ajax_render_block', block: this.getAttribute('block') },
        complete: data => {
          if(data?.responseJSON?.success){
            const parser = new DOMParser()
            const doc = parser.parseFromString(data.responseJSON.data, 'text/html')
            const container = doc.querySelector('ajax-renderer')
            if(container){
              this.innerHTML = container.innerHTML
            }
          }
        }
      })
    }
  }

  customElements.define("ajax-renderer", ajaxRenderer)
}